
import { computed } from "vue";
import { Options } from "vue-class-component";
import BaseElement from "../BaseElement.vue";

@Options({
  props: [
    "icon",
    "iconPos",
    "badge",
    "badgeClass",
    "buttonType",
    "card",
    "matIcon"
  ],
  emits: ["click"]
})
export default class IziButton extends BaseElement {
  public icon!: string;
  public matIcon!: string;
  public iconPos!: string;
  public badge!: string;
  public badgeClass!: string;
  public buttonType!: string; //primary || other || cancel
  public bindingClass = computed(() => this.mergeClass());
  public card!: boolean;
  public handeleEventClick() {
    this.$emit("click");
  }

  protected mergeClass() {
    return `${this.buttonType} ${this.checkSizeButton()} ${this.checkTheme()} ${
      this.class
    } ${this.card ? "p-shadow-3" : ""}`;
  }
  protected checkTheme() {
    if (this.theme) {
      //icons, severities, raised, rounded, text, raised, outlined, rounded
      return `p-button-${this.theme}`;
    }
    return "";
  }
  protected checkSizeButton() {
    if (this.size) {
      return this.size ? `p-button-${this.size}` : "";
    }
    return "";
  }
}
